import {Mix} from "../core/Reflection";
import {Button, OutlinedButton, PulsatingButton} from "./Button";

export class SplashPlayButton extends OutlinedButton {

}
